import React from "react";
import { Link } from "react-router-dom";
import { Zoom } from 'react-awesome-reveal';
import Button from "../../button/Button";
import DynamicSolutionDemo from "./DynamicSolutionDemo";
import ProgressiveHintingDemo from "./ProgressiveHintingDemo";
import DrawingCanvasDemo from "./DrawingCanvasDemo";
import MindMapsDemo from "./MindMapsDemo";
// import Board from "../../Board"
// import Solution from "../../Solution";

import "./Features.css";

const solution = [
    {"step_start": "x = 1/(R_(si) + sum_(i=1)^n(s_n/lambda_n) + R_(se))"},
    {"step": "= 1/(R_(1) + sum_(i=1)^n(s_n/lambda_n) + R_(se))"},
    {"step": "= 1/(R_(2) + sum_(i=1)^n(s_n/lambda_n) + R_(se))"},
    {"insight": "color(#ff0000)(f(x) = dy/dx)"},
    {"text": "This is explanatory text in the exo "},
    {"step": "= 1/(R_(si) + sum_(i=1)^n(s_n/lambda_n) + R_(se)) + 1/(R_(si) + sum_(i=1)^n(s_n/lambda_n) + R_(se))"},
    {"step_start": "1/(R_(si) + sum_(i=1)^n(s_n/lambda_n) + R_(se))"},
    {"step": "= 1/(R_(si) + sum_(i=1)^n(s_n/lambda_n) + R_(se))"}, 
    {"insight": "color(#ff0000)(f(x) = dy/dx)"},
    {"step": "= 1/(R_(si) + sum_(i=1)^n(s_n/lambda_n) + R_(se))"}];

const hints = [];

/*TODO: Add more react-reveal effects*/

const Features = () => {
    return(
        <div className="features-div" id="features-section">

            <Zoom Right>
                <div className="feature" id="hints-feature">
                    <div className="feature-illustration">
                        <ProgressiveHintingDemo />
                    </div>
                    <div className="description">
                        <div className="title"><h3>Progressive Hinting 💡</h3></div>
                        <div className="description-text">
                            <p>Get inspired by hints before peeking at the solution. Each click on
                                the <strong>Hint</strong> button reveals one more nudge — just
                                enough to keep you thinking, never enough to spoil the answer.</p>
                        </div>
                    </div>
                </div>
            </Zoom>

            <Zoom Left>
                <div className="feature" id="interactive-solution-feature">
                    <div className="feature-illustration">
                        <DynamicSolutionDemo />
                    </div>
                    <div className="description">
                        <div className="title"><h3>Dynamic Solution 📐</h3></div>
                        <div className="description-text">
                            <p>A solution with detailed steps that you can interact with.
                                Use <strong>Next</strong> and <strong>Previous</strong> to reveal
                                one step at a time, or jump straight to the full solution.</p>
                        </div>
                    </div>
                </div>
            </Zoom>

            <Zoom Right>
                <div className="feature" id="draft-board-feature">
                    <div className="feature-illustration">
                        <DrawingCanvasDemo />
                    </div>
                    <div className="description">
                        <div className="title"><h3>Drawing Canvas 🖊️</h3></div>
                        <div className="description-text">
                            <p>The best way to stimulate memory is to write by hand. Sketch
                                curves, jot equations, switch colors, the draft board lets you
                                think on paper without leaving the page.</p>
                        </div>
                    </div>
                </div>
            </Zoom>



            {/* <Zoom Right>
                <div className="feature" id="collaborative-learning-feature">
                    <img src={require("../../../assets/images/collaborative_learning.png")} id="collaborative_learning" alt=""/>
                    <div className="description">
                        <div className="title"><h3>Collaborative Learning</h3></div>
                        <div className="description-text">
                            <p>With the collaborative mode, you can solve the exercise online with
                                your teacher or friends, you collaborate or even compete!</p>
                        </div>
                    </div>
                </div>
            </Zoom> */}

            <Zoom Left>
                <div className="feature" id="mind-maps-feature">
                    <div className="feature-illustration">
                        <MindMapsDemo />
                    </div>
                    <div className="description">
                        <div className="title"><h3>Mind Maps 🗺️</h3></div>
                        <div className="description-text">
                            <p>Visualize how every topic, concept, and technique connects in one
                                interactive mind map. Click any branch to jump straight into practice, perfect for quick revision before an exam.</p>
                        </div>
                    </div>
                </div>
            </Zoom>

            <div className="features-cta">
                <Link to="/titles" style={{ textDecoration: 'none' }}>
                    <Button id="getting-started-button" text="Getting Started" newTab={false} href=""/>
                </Link>
            </div>

        </div>
    )
}

export default Features;